import * as React from 'react';
export const fidelitySvg = React.forwardRef(function fidelitySvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#368728',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'm15.946 12.989-2.724 4.4.818.581h-1.174l-1.034 1.663-4.41 2.325-.073.02s-.013-.034 0-.034l5.497-4.704-7 .825s-.014-.034 0-.048l6.785-2.007-6.819-2.007s-.027-.034 0-.047l7.034.75-5.51-4.57s.02-.026.033-.026l6.195 3.413-3.269-6.292s.027-.027.034-.014l4.335 5.684-.503-7.353s.034-.014.047 0l1.839 7.09 2.1-6.88s.048 0 .048.013l-.88 7.09 4.564-5.394s.027.014.027.027L18.409 13.7l6.33-3.224s.06-.014.046.007l-5.63 4.291 7.194-.473s.013.034-.013.034l-7.014 1.71 6.752 2.379.047.04s-.014.02-.034.02l-7.154-1.1 5.537 4.811s0 .048-.027.048l-4.228-2.373 3.04 5.096c1.765-1.412 3.054-3.4 3.678-5.467.986-3.116.53-6.59-1.094-9.327-1.45-2.488-3.953-4.4-6.59-5.164-2.31-.716-5.215-.615-7.383.29C9.1 6.326 6.51 8.827 5.43 11.598c-1.155 2.696-1.155 6.069-.027 8.752 1.053 2.771 3.577 5.238 6.302 6.306l2.463-7.678h5.496l-1.2-.784h-4.088l1.584-5.204h-.014ZM4 16.078C4 9.407 9.376 4 16 4s12 5.407 12 12.078C28 22.748 22.624 28 16 28S4 22.755 4 16.078Z',
      fill: '#fff',
    }),
  );
});
fidelitySvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var fidelity = {
  category: 'brand',
  colorable: false,
  name: 'fidelity',
  svg: fidelitySvg,
};
